import Button from 'components/Button';
import Error from 'components/form/Error';
import { FC, useCallback, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import useSWR, { mutate } from 'swr';
import MentorForm from 'types/MentorForm';
import privateAPI from 'utils/privateAxiosInstance';
import { getLocaleDate, getLocaleTime } from 'utils/time';
import { MentorEditContext } from '.';

const Container = styled.section`
  max-width: 50rem;

  align-self: center;

  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--gray-600);

  p {
    width: 100%;
  }

  button {
    margin-top: 1rem;
  }
`;

const MentorTraining: FC = () => {
  const { mentor } = useContext(MentorEditContext);
  const { id } = useParams();
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { data: mentorForm } = useSWR<MentorForm>(
    `/calendly/training-info/${id}`,
  );

  const handleSetFacultative = useCallback(() => {
    setError(false);
    setLoading(true);
    privateAPI
      .post(`/calendly/training-facultative/${id}`)
      .then(() => {
        setLoading(false);
        mutate('/user/mentors');
        mutate(`/user/${id}`);
        mutate(`/calendly/training-info/${id}`);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [id]);

  if (mentor?.mentorStatus === 'TRAINING_REGISTERED') {
    return (
      <Container>
        <p>
          Ce mentor est inscrit à la formation
          {mentorForm?.eventStartDate
            ? ` du ${getLocaleDate(mentorForm.eventStartDate)} à ${
                mentorForm?.eventStartDate &&
                getLocaleTime(mentorForm.eventStartDate)
              }.`
            : '.'}
        </p>
      </Container>
    );
  }

  if (mentor?.mentorStatus === 'TRAINING') {
    return (
      <Container>
        {error && <Error>Une erreur est survenue.</Error>}
        <p>Ce mentor n'a pas encore choisi de créneau pour sa formation.</p>
        <p>
          Vous pouvez rendre la formation facultative pour ce mentor à l'aide du
          bouton ci-dessous.
        </p>
        <div>
          <Button
            color="primary"
            loading={loading}
            onClick={handleSetFacultative}
          >
            Rendre la formation facultative
          </Button>
        </div>
      </Container>
    );
  }

  return null;
};

export default MentorTraining;
